<div class="modal-content">
  <div class="modal-header">
    <p class="heading lead"> {{ heading }} </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.close()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <div [innerHTML]="guidance"></div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-list-item-selector [items]="items" (itemSelected)="onItemSelected($event)"></app-list-item-selector>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" pButton class="waves-light" (click)="closeWithoutSelect()" aria-label="Close"><i
      [ngClass]="[cancelButtonIcon, 'eca-btn-' + cancelButtonColour]" *ngIf="cancelButtonIcon"></i> {{cancelButtonText}}</button>
  </div>
</div>
